import React from 'react'

const Heading = ({text,color}) => {
  return (
    <div className="h-8 font-poppins pb-[15px] w-full bg-violet-200 rounded-full flex justify-center items-center mt-5 font-extrabold text-xl" style={{background:color,color:"white"}}>{text}</div>
  )
}

export default Heading





export const Heading01 = ({text,color}) => {
  return (
    <div className="h-8 font-poppins w-full rounded-full flex justify-center items-center mt-5 font-extrabold text-xl" style={{background:color,color:"white"}}>{text}</div>
  )
}

// export default Heading01